import * as React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { Tooltip, Props as TooltipProps } from './Tooltip';

import './index.scss';

const b = b_.with('input-view');

export type TooltipPlacement = TooltipProps['position'];

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  classNameInput?: string;
  classNameLabel?: string;
  classNameError?: string;
  classNameHint?: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  hintIsPermanent?: boolean;
  tooltipPlacement?: TooltipProps['position'];
  inside?: React.ReactNode;
  input?: any;
  meta?: any;
  isBig?: boolean;
}

type Enhanced = Props;

export const InputView: React.FC<Enhanced> = ({
  input,
  meta,
  className,
  placeholder,
  classNameLabel,
  classNameInput,
  classNameHint,
  classNameError,
  tooltipPlacement,
  label,
  children,
  hint,
  hintIsPermanent,
  isBig,
  inside,
  onChange,
  ...props
}) => {
  const inputField = React.useRef<HTMLInputElement>(null);

  const onInputViewClick = () => {
    inputField.current !== null && inputField.current.focus();
  };

  return (
    <div onClick={onInputViewClick} className={cn(b({ big: isBig }), className)}>
      <div className={b('inner')}>
        {label && (
          <label
            className={cn(b('label'), classNameLabel)}
            htmlFor={input.name}
            data-testid="label"
          >
            {label}
          </label>
        )}
        <input
          ref={inputField}
          className={cn(b('input'), classNameInput)}
          placeholder={placeholder || ''}
          id={input.name}
          {...props}
          {...input}
          data-testid={`${input.name}-input`}
        />
        {inside && <div className={b('inside')}>{inside}</div>}
      </div>
      <Tooltip
        name={input.name}
        error={meta.submitFailed && meta.error}
        classNameHint={classNameHint}
        classNameError={classNameError}
        position={tooltipPlacement || 'bottomRight'}
        hint={(!input.value || !input.value.length || hintIsPermanent) && hint ? hint : null}
      />
      {children}
    </div>
  );
};
